import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';

const Header: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AppBar position="fixed" sx={{ bgcolor: '#9c4f96' }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            Thayne Silva Prado
          </Typography>
          <Typography variant="caption" component="div" sx={{ opacity: 0.9 }}>
            Cirurgiã-Dentista — CRO/PR 38004
          </Typography>
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
          <Button color="inherit" onClick={() => scrollToSection('home')}>
            Início
          </Button>
          <Button color="inherit" onClick={() => scrollToSection('services')}>
            Serviços
          </Button>
          <Button color="inherit" onClick={() => scrollToSection('about')}>
            Sobre
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: 'white', color: '#9c4f96', '&:hover': { bgcolor: '#f5f5f5' } }}
            startIcon={<CalendarMonth />}
            onClick={() => scrollToSection('appointment')}
          >
            Agendar
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;